<ul class="filter-tabs">
  @for (tab of tabs(); track $index) {
    <li
      class="filter-tabs__item"
      [class]="{ 'filter-tabs__item--selected': tab.isSelected() }"
      (click)="selectTab($index)"
    >
      @if (tab.labelTemplate(); as labelTemplate) {
        <ng-template [ngTemplateOutlet]="labelTemplate" />
      } @else {
        {{ tab.label() }}
      }
    </li>
  }
</ul>

<div class="tab-content">
  <ng-content />
</div>
